import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyBP1AwT6o71ay0H7BmOGKPy6kChabIy9EU",
  authDomain: "agdysa-52935.firebaseapp.com",
  projectId: "agdysa-52935",
  storageBucket: "agdysa-52935.firebasestorage.app",
  messagingSenderId: "865989661383",
  appId: "1:865989661383:web:7e01d68d0114415f11a4e2",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

/** App Check opcional: VITE_FIREBASE_APPCHECK_SITE_KEY (reCAPTCHA v3). No enforce en Functions hasta configurar. */
const appCheckKey = String(import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY || "").trim();
if (appCheckKey && typeof window !== "undefined") {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch {
    /* already init */
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app); // (default) — website CMS
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
export default app;
